import React from 'react';

import { ManageContractsApp } from '../contractManagementContext';
import HouseType from '../sections/HouseType';
import StartDate from '../sections/StartDate';
import NewContract from '../sections/NewContract';
import ExtraServices from '../sections/ExtraServices';
import Billing from '../sections/Billing';

export const ChangeType: React.FunctionComponent = () => {
  const { useVaihtoturva } = ManageContractsApp.useState();

  return (
    <>
      {(!useVaihtoturva || useVaihtoturva?.length === 0) && <HouseType />}
      <NewContract />
      <StartDate />
      <ExtraServices />
      {useVaihtoturva && useVaihtoturva.length > 0 && <Billing />}
    </>
  );
};

export default ChangeType;
